import {v4 as uuid} from "uuid";

export class Sort {
    private _id: string;
    private readonly _title: string;
    private readonly _field: string;
    private readonly _value: 'asc'|'desc';
    private readonly _default: boolean;

    constructor(title: string, field: string, value: 'asc'|'desc', _default: boolean = false) {
        this._id = uuid();
        this._title = title;
        this._field = field;
        this._value = value;
        this._default = _default;
    }

    get default(): boolean {
        return this._default;
    }

    public equals(sort: Sort): boolean {
        return sort.id === this.id;
    }

    get id(): string {
        return this._field + '=' + this._value;
    }

    get title(): string {
        return this._title;
    }

    get field(): string {
        return this._field;
    }

    get value(): "asc" | "desc" {
        return this._value;
    }
}
